/* Módulo "Formulário": perguntas de escolha única sem resposta certa, no estilo
   Google Forms.

   A rota (/formulario e /formulario/allocate/:id) e o item de menu vêm do
   cadastro do backend (configuration_links, configuration_menus,
   access_roles_menus e access_roles_links), como as demais telas do AVA. O
   path abaixo precisa bater com o cadastrado em configuration_links. */

export const FORMULARIOS_PATH = "/formulario";

const ADM_EDUCANDUS = 1;

/** Quem recebe o aviso de formulários pendentes ao entrar: qualquer perfil,
 * porque o agendamento por público alcança professores e administradores
 * também. Quem não tem nada pendente não vê aviso nenhum. */
export const isRespondenteDeFormularios = roleId => Number(roleId) > 0;

/* Quem vê a listagem de gestão (criar, editar, agendar, resultados) em vez dos
   cards de responder: adm Educandus, adm de grupo e professor — os mesmos de
   FormularioController::PAPEIS_GESTORES. O adm de grupo enxerga só os
   formulários do grupo dele (o backend filtra). Os demais perfis respondem. */
const ADM_GRUPO = 2;
const PROFESSOR = 6;
const PAPEIS_GESTORES = [ADM_EDUCANDUS, ADM_GRUPO, PROFESSOR];

export const isGestorDeFormularios = roleId =>
  PAPEIS_GESTORES.includes(Number(roleId));

const normalizar = texto =>
  String(texto || "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .trim();

/* O tipo de conteúdo "Formulário" é reconhecido pelo NOME, nunca pelo id: o id
   muda de base para base (no ava_homologa é 36). O backend faz o mesmo, em
   FormularioController::tiposConteudoFormulario. */
export const isTipoFormulario = nome => normalizar(nome) === "formulario";
